import { CommonModule } from '@angular/common'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart'
import {
  CategoryPageMetaResolver,
  CmsConfig,
  I18nModule,
  ProductPageMetaResolver,
  ProductSearchAdapter,
  provideConfig,
  provideDefaultConfigFactory,
  RoutingService,
  UrlModule,
  WindowRef
} from '@spartacus/core'
import {
  CarouselModule,
  CmsPageGuard,
  CurrentProductService,
  GenericLinkModule,
  IconModule,
  ListNavigationModule,
  MediaModule,
  PageLayoutComponent,
  PageSlotModule,
  ProductFacetService,
  ProductListComponentService,
  ProductListItemContextSource,
  ProductListModule,
  SpinnerModule,
  TableModule
} from '@spartacus/storefront'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { EbComponentsModule } from 'src/app/components/eb-components.module'
import { EbButtonModule } from '../../components/cms-button/eb-button.module'
import { EbDocumentLinkModule } from '../../components/document-link/eb-document-link.module'
import { EbDropdownModule } from '../../components/dropdown/eb-dropdown.module'
import { EbGenericScrollModule } from '../../components/generic-scroll/eb-generic-scroll.module'
import { EbGroupedFavoritesModule } from '../../components/grouped-favorites/eb-grouped-favorites.module'
import { EbInfoBoxModule } from '../../components/info-box/eb-info-box.module'
import { EbLoadMoreButtonModule } from '../../components/load-more-button/eb-load-more-button.module'
import { EbSelectBoxModule } from '../../components/select-box/eb-select-box.module'
import { EbSpinnerModule } from '../../components/spinner/eb-spinner.module'
import { EbSuccessorComponent } from '../../components/successor/eb-successor.component'
import { EbSuccessorModule } from '../../components/successor/eb-successor.module'
import { EbAuthService } from '../auth/services/eb-auth.service'
import { EbCartModule } from '../cart/eb-cart.module'
import { EbCarouselComponent } from './components/eb-carousel/eb-carousel.component'
import { EbCarouselService } from "./components/eb-carousel/eb-carousel.service"
import { EbProductAvailabilityModule } from './components/product-availability/eb-product-availability.module'
import { EbProductDetailComponent } from './components/product-detail/eb-product-detail.component'
import { EbTruncateTextDirective } from './components/product-detail/eb-truncate-text.directive'
import { EbProductFacetNavigationModule } from './components/product-facet-navigation/eb-product-facet-navigation.module'
import { EbFacetModule } from './components/product-facet-navigation/facet/eb-facet.module'
import { EbProductGridComponent } from './components/product-grid/eb-product-grid.component'
import { EbProductGridItemComponent } from './components/product-grid-item/eb-product-grid-item.component'
import { EbProductImagesComponent } from './components/product-images/eb-product-images.component'
import { EbProductScrollComponent } from './components/product-scroll/eb-product-scroll.component'
import { EbProductSpecsTabComponent } from './components/product-specs-tab/eb-product-specs-tab.component'
import { EbProductVariantsFilterComponent } from './components/product-variants-filter/eb-product-variants-filter.component'
import { EbProductVariantsTableActionsComponent } from './components/product-variants-table/eb-product-variants-table-actions.component'
import { ebVariantsTableConfigFactory } from './components/product-variants-table/eb-product-variants-table-config'
import { EbProductVariantsTableDefaultComponent } from './components/product-variants-table/eb-product-variants-table-default.component'
import { EbProductVariantsTableLinkComponent } from './components/product-variants-table/eb-product-variants-table-link.component'
import { EbProductVariantsTableComponent } from './components/product-variants-table/eb-product-variants-table.component'
import { EB_PRODUCT_SEARCH_PAGE_NORMALIZER } from './converters/converters'
import { EbProductSearchPageNormalizer } from './converters/normalizers/eb-product-search-page.normalizer'
import { ebProductGridLayoutConfig } from './eb-product-layout.config'
import { interceptors } from './interceptor'
import { EbAvailabilityAdapter } from './services/connectors/eb-availability.adapter'
import { EbPricesAdapter } from './services/connectors/eb-prices.adapter'
import { EbProductDetailAdapter } from './services/connectors/eb-product-detail.adapter'
import { EbProductSearchAdapter } from './services/connectors/eb-product-search.adapter'
import { EbProductAdapter } from './services/connectors/eb-product.adapter'
import { EbAvailabilityService } from './services/facades/eb-availability.service'
import { EbCategoryPageMetaResolver } from './services/facades/eb-category-page-meta.resolver'
import { EbCurrentProductService } from './services/facades/eb-current-product.service'
import { EbPricesService } from './services/facades/eb-prices.service'
import { EbProductDetailService } from './services/facades/eb-product-detail.service'
import { EbProductFacetService } from './services/facades/eb-product-facet.service'
import { EbProductListComponentService } from './services/facades/eb-product-list-component.service'
import { EbProductPageMetaResolver } from './services/facades/eb-product-page-meta.resolver'
import { EbProductService } from './services/facades/eb-product.service'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'variant' }
      }
    ]),
    CommonModule,
    IconModule,
    I18nModule,
    RouterModule,
    MediaModule,
    UrlModule,
    IconModule,
    ProductListModule,
    ListNavigationModule,
    InfiniteScrollModule,
    SpinnerModule,
    CarouselModule,
    AddToCartModule,
    PageSlotModule,
    EbSpinnerModule,
    TableModule,
    EbGenericScrollModule,
    NgbTooltipModule,
    EbInfoBoxModule,
    EbDocumentLinkModule,
    EbCartModule,
    EbProductAvailabilityModule,
    EbProductFacetNavigationModule,
    EbSelectBoxModule,
    EbSuccessorModule,
    EbFacetModule,
    EbLoadMoreButtonModule,
    EbDropdownModule,
    EbGroupedFavoritesModule,
    EbButtonModule,
    GenericLinkModule,
    EbComponentsModule
  ],
  exports: [],
  declarations: [
    EbProductDetailComponent,
    EbProductImagesComponent,
    EbProductGridComponent,
    EbProductGridItemComponent,
    EbProductScrollComponent,
    EbProductVariantsTableComponent,
    EbProductVariantsTableActionsComponent,
    EbProductVariantsTableLinkComponent,
    EbProductVariantsTableDefaultComponent,
    EbProductDetailComponent,
    EbProductImagesComponent,
    EbProductSpecsTabComponent,
    EbProductVariantsFilterComponent,
    EbCarouselComponent,
    EbTruncateTextDirective
  ],
  providers: [
    ...interceptors,
    provideConfig({
      cmsComponents: {
        ProductSummaryComponent: {
          component: EbProductDetailComponent
        },
        ProductImagesComponent: {
          component: EbProductImagesComponent
        },
        ProductGridComponent: {
          component: EbProductGridComponent
        },
        SearchResultsGridComponent: {
          component: EbProductGridComponent
        },
        VariantsListComponent: {
          component: EbProductVariantsTableComponent
        },
        SuccessorComponent: {
          component: EbSuccessorComponent
        },
        ProductSpecsTabComponent: {
          component: EbProductSpecsTabComponent
        }
      }
    } as CmsConfig),
    ProductListItemContextSource,
    EbPricesService,
    EbPricesAdapter,
    EbAvailabilityService,
    EbAvailabilityAdapter,
    EbProductAdapter,
    EbCurrentProductService,
    EbProductService,
    EbCarouselService,
    {
      provide: CurrentProductService,
      useClass: EbCurrentProductService
    },
    {
      provide: ProductPageMetaResolver,
      useClass: EbProductPageMetaResolver
    },
    {
      provide: CategoryPageMetaResolver,
      useClass: EbCategoryPageMetaResolver
    },
    {
      provide: ProductListComponentService,
      useClass: EbProductListComponentService
    },
    {
      provide: ProductFacetService,
      useClass: EbProductFacetService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: EbProductDetailService.checkForEncryptedArticleNumber,
      multi: true,
      deps: [EbAuthService, WindowRef, EbProductService, RoutingService]
    },
    EbProductDetailService,
    EbProductDetailAdapter,
    provideDefaultConfigFactory(ebVariantsTableConfigFactory),
    provideConfig(ebProductGridLayoutConfig),
    {
      provide: EB_PRODUCT_SEARCH_PAGE_NORMALIZER,
      useExisting: EbProductSearchPageNormalizer,
      multi: true
    },
    {
      provide: ProductSearchAdapter,
      useClass: EbProductSearchAdapter
    }
  ]
})
export class EbProductModule {}
